import { Clipboard as ArkClipboard } from '@ark-ui/react';

import { cn } from '../../lib/utils';

function ClipboardRoot({ className, ...props }: ArkClipboard.RootProps) {
	return <ArkClipboard.Root className={cn('pt-clipboard', className)} {...props} />;
}

function ClipboardRootProvider(props: ArkClipboard.RootProviderProps) {
	return <ArkClipboard.RootProvider {...props} />;
}

function ClipboardLabel({ className, ...props }: ArkClipboard.LabelProps) {
	return <ArkClipboard.Label className={cn('pt-clipboard-label', className)} {...props} />;
}

function ClipboardControl({ className, ...props }: ArkClipboard.ControlProps) {
	return <ArkClipboard.Control className={cn('pt-clipboard-control', className)} {...props} />;
}

function ClipboardInput({ className, ...props }: ArkClipboard.InputProps) {
	return <ArkClipboard.Input className={cn('pt-clipboard-input', className)} {...props} />;
}

function ClipboardTrigger({ className, ...props }: ArkClipboard.TriggerProps) {
	return <ArkClipboard.Trigger className={cn('pt-clipboard-trigger', className)} {...props} />;
}

function ClipboardIndicator({ className, ...props }: ArkClipboard.IndicatorProps) {
	return <ArkClipboard.Indicator className={cn('pt-clipboard-indicator', className)} {...props} />;
}

function ClipboardValueText({ className, ...props }: ArkClipboard.ValueTextProps) {
	return <ArkClipboard.ValueText className={cn('pt-clipboard-value-text', className)} {...props} />;
}

const Clipboard = {
	Root: ClipboardRoot,
	RootProvider: ClipboardRootProvider,
	Label: ClipboardLabel,
	Control: ClipboardControl,
	Input: ClipboardInput,
	Trigger: ClipboardTrigger,
	Indicator: ClipboardIndicator,
	ValueText: ClipboardValueText,
	Context: ArkClipboard.Context
};

export { Clipboard };
